import React from "react"

interface HorizontalArrowProps {
  style?: "black" | "green" | "red" | "orange" | "violet"
}

const HorizontalArrow: React.FC<HorizontalArrowProps> = ({ style = "black" }) => {
  let bgColor = ""
  let borderColor = ""

  switch (style) {
    case "black":
      bgColor = "bg-black"
      borderColor = "border-l-black"
      break
    case "green":
      bgColor = "bg-green-500"
      borderColor = "border-l-green-500"
      break
    case "red":
      bgColor = "bg-red-500"
      borderColor = "border-l-red-500"
      break
    case "orange":
      bgColor = "bg-orange-500"
      borderColor = "border-l-orange-500"
      break
    case "violet":
      bgColor = "bg-violet-500"
      borderColor = "border-l-violet-500"
      break
  }

  return (
    <div className="flex items-center w-full">
      <div className={`h-1 w-full ${bgColor}`} />
      <div className="relative flex items-center justify-center w-4 h-4">
        <div
          className={`h-0 w-0 border-y-8 border-y-transparent border-l-[16px] ${borderColor}`}
        ></div>
      </div>
    </div>
  )
}

export default HorizontalArrow
